/**
 * What swapping the active Pokémon with a benched one does, in words: "Charmeleon goes to the Bench and Machop comes
 * up". For a retreat and Switch.
 *
 * @param {Map|undefined} active the active Pokémon (its card's name)
 * @param {Map|undefined} bench the bench (its cards, by order)
 * @param {number} benchPosition the one coming up
 */
export function swapWords(active, bench, benchPosition) {
  const goes = active ? active.getIn(['card', 'name'], 'Your Pokémon') : 'Your Pokémon';
  const coming = bench && bench.get('cards').find(card => card.get('order') === benchPosition);
  return `${goes} goes to the Bench and ${coming ? coming.get('name') : 'the benched Pokémon'} comes up`;
}
